// client/src/components/pages/LexiStar/NotificationRules/notificationsApi.js
//
// The U2 pages' door to M3-A2's notifications client
// (services/lexistarNotifications.js; m3-contracts §7.2,
// server/modules/lexistar/notifications): rules, recipient groups, templates
// and the preview, channel budgets, tenant settings, the delivery log and the
// in-app centre. Three calls get a thin shim so the pages pass one object
// everywhere; the rest are the service's own functions. Plus loose envelope
// helpers for the bodies.

import {
  testRule as serviceTestRule,
  getBudgets as serviceGetBudgets,
  markNotificationsRead as serviceMarkRead,
} from '../../../../services/lexistarNotifications';

export {
  listRules,
  createRule,
  updateRule,
  listGroups,
  createGroup,
  updateGroup,
  listTemplates,
  updateTemplate,
  previewTemplate,
  updateBudgets,
  getTenantSettings,
  updateTenantSettings,
  listMessages,
  getMessage,
  getCostLedger,
  getDeliverySlo,
  listNotifications,
} from '../../../../services/lexistarNotifications';

/** { event_id } → POST /notification-rules/:id:test (rendered and sent to the caller only). */
export const testRule = (id, { event_id: eventId }) => serviceTestRule(id, eventId);

/** { month: 'YYYY-MM' } → GET /channel-budgets?month. */
export const getBudgets = ({ month } = {}) => serviceGetBudgets(month);

/** { ids: [...] } or { all: true } → POST /notifications:markRead. */
export const markNotificationsRead = ({ ids, all } = {}) => serviceMarkRead(all ? 'all' : ids);

// ── Envelope helpers (bodies are { rules } / { groups } / …, tolerated loosely) ──

export const pickRows = (res, ...keys) => {
  if (Array.isArray(res)) return res;
  if (!res || typeof res !== 'object') return [];
  for (const k of [...keys, 'data', 'rows', 'items']) if (Array.isArray(res[k])) return res[k];
  return [];
};

export const pickObject = (res, ...keys) => {
  if (!res || typeof res !== 'object' || Array.isArray(res)) return null;
  for (const k of keys)
    if (res[k] && typeof res[k] === 'object' && !Array.isArray(res[k])) return res[k];
  return res;
};

/**
 * The rendered preview (POST /message-templates:preview → { key, channel,
 * language, language_fallback, body, buttons, characters, segments?,
 * template: { source, version, provider_status? } }), tolerant of a wrapped body.
 */
export function renderedOf(res) {
  const r = pickObject(res, 'rendered', 'preview') || {};
  const segments = res?.segments ?? r.segments ?? null;
  return {
    body: String(r.body ?? r.text ?? ''),
    buttons: Array.isArray(r.buttons) ? r.buttons : [],
    segments: segments && typeof segments === 'object' ? segments : null,
    providerStatus:
      r.providerStatus ??
      r.provider_status ??
      res?.template?.provider_status ??
      res?.provider_status ??
      null,
    languageFallback: !!(res?.language_fallback ?? r.language_fallback),
    source: res?.template?.source ?? null,
  };
}
